'use client'

import React, { ReactElement, useContext } from 'react'
import { ContextMenu } from '../../molecules'
import { Button, ButtonVariants } from '../../atoms'
import { FilterIcon } from '../../icons'
import { ComponentTranslationContext } from '../../../providers'
import { MESSAGE_KEYS } from '../../../constants/messageKeys'

interface TimelineFilterWrapperProps extends React.HTMLAttributes<HTMLDivElement> {}

export const TimelineFilterWrapper = ({ children }: TimelineFilterWrapperProps): ReactElement => {
    if (!children) return <></>
    const translations = useContext(ComponentTranslationContext)

    return (
        <ContextMenu
            interactionMode="dialog"
            className="max-h-[70%] overflow-y-scroll"
            toggleButton={
                <Button variant={ButtonVariants.QUIET} icon={<FilterIcon />}>
                    {translations.getLabel(MESSAGE_KEYS.FILTERS)}
                </Button>
            }
        >
            {children}
        </ContextMenu>
    )
}
